import {writable} from 'svelte/store'

export const years = writable([])
export const perPage = 100
export let mobileFiltersOpen = writable(false)
export let searchQuery = writable('')